import React from 'react';

const CheckmarkBlack = () => (
  <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 7L7.5 12.5L18 1.5" stroke="#150544" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);

export default CheckmarkBlack;
